<template>
  <v-app id="app">
    <component :is="layout">
      <router-view :key="$route.fullPath"/>
    </component>
  </v-app>
</template>

<script>
import Component from 'vue-class-component';
import { Geolocation } from '@capacitor/geolocation';
import { Getter, Action, Mutation } from 'vuex-class';
import Vue from 'vue';
import scriptjs from 'scriptjs';
import { CORDOVA_SET_VERSION } from '@/apps/cordova/store/types';
import DesktopLayout from '@/layouts/DesktopLayout';
import MobileLayout from '@/layouts/MobileLayout';
import KioskLayout from '@/layouts/KioskLayout';
import { REST_LIST } from '@/apps/desktop/store/types';
import { AUTH_GUEST_TOKEN } from '@/apps/auth/store/types';

/**
 * Default application layout. It is possible to dynamically activate other
 * layouts here via `layout` data property.
 *
 * DATA
 * ============================================================================
 * @prop boolean drawer - defines if drawer should be displayed
 * @prop layoutComponent - defines current layout component. Component should
 * have 1 slot to receive router view component.
 */
@Component({
  name: 'default-layout',
})
export default class DefaultLayout extends Vue {
  get layout() {
    const platform = process.env.PLATFORM;

    if (platform === 'web') {
      return DesktopLayout;
    } else if (platform === 'mobile') {
      scriptjs('https://pay.google.com/gp/p/js/pay.js');

      return MobileLayout;
    } else if (platform === 'kiosk') {
      return KioskLayout;
    }

    return DesktopLayout;
  }

  @Getter version;
  @Action(REST_LIST) actionRestaurants;
  @Action(AUTH_GUEST_TOKEN) getGuestToken;

  @Getter userType;
  @Getter authToken;
  @Getter isGuest;
  @Getter isKioskPlatform;
  @Mutation(CORDOVA_SET_VERSION) setVersion;

  created() {
    this.$store.commit(CORDOVA_SET_VERSION, process.env.CORDOVA_APP_VERSION);

    if (this.isGuest) {
      this.getGuestToken();
    }

    if (this.isKioskPlatform) {
      this.actionRestaurants({});
    } else {
      Geolocation.watchPosition({}, (position) => {
        if (!position) {
          this.actionRestaurants({});

          return;
        }

        this.actionRestaurants({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }

    this.setVersion(process.env.CORDOVA_APP_VERSION);
  }
}
</script>

<style lang='scss' module>
  @import "~normalize.css";
  @import "@/style/global.scss";
  @import "@/style/fonts.scss";
  @import "@/style/variables.scss";

  html, body {
    font-family: $main-font-family;
    font-size: $base-font-size;
    color: $black;
    overflow: auto;
    overflow-y: scroll;
    -webkit-overflow-scrolling: auto;
  }

  body {
    overflow: hidden;
  }

  .homeBg {
    display: flex;
    flex-direction: column;
  }
</style>

<style>
.v-navigation-drawer--temporary {
  z-index: 999;
}

.v-overlay {
  z-index: 998;
}

.v-menu__content {
  margin-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/MainLayout.vue